import authHeaders from 'helpers/auth-header';
import request from './api';

function getDefinition(path, params) {
  return request({
    url: `/definition/${path}/all`,
    method: 'GET',
    headers: authHeaders(),
    params: { ...params },
  });
}

const definition = {
  getDefinition,
};

export default definition;
